import { Component, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AncillaryLinkItem } from '@interfaces/ancillary-network.model';
import { TrackByUtilities } from '../../utilities/trackByFn.utilities';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionManager } from '@zelis/platform-ui-components';

@Component({
  selector: 'app-ancillary-networks',
  templateUrl: './ancillary-networks.component.html',
  styleUrls: ['./ancillary-networks.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AncillaryNetworksComponent implements OnDestroy {
  @Input() classes: string = '';
  @Input() ancillaryNetworks: AncillaryLinkItem[];

  public trackByNetworkLabel: any = TrackByUtilities.getTrackByFn('label');
  public subscriptions: SubscriptionManager = new SubscriptionManager();

  constructor(private translateService: TranslateService) {}

  ngOnDestroy() {
    this.subscriptions.destroy();
  }

  public openNetworkLink(networkLink: string) {
    this.subscriptions.add(
      this.translateService.get(networkLink).subscribe((data) => {
        window.open(data, '_blank');
      })
    );
  }
}
